import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import materialUI from "material-UI";
import * as S from "./styles";

interface Props {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  color?: string;
  removePadding?: boolean;
}

const useStyles = materialUI.makeStyles({
  root: {
    color: "#D0D5DD",
    "&.Mui-checked": {
      color: "#2D5BFF",
    },
    "&.Mui-disabled": {
      color: "#B0B0B0",
    },
  },
});

const CheckboxComponent: React.FC<Props> = ({
  label,
  checked,
  onChange,
  disabled = false,
  color = "#2D5BFF",
  removePadding,
}) => {
  const _sx = {
    color: "#000000",
    opacity: 0.6,
    "&.Mui-checked": {
      color,
      opacity: 1,
    },
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          classes={{ root: useStyles().root }}
          sx={
            removePadding
              ? {
                  ..._sx,
                  padding: 0,
                }
              : _sx
          }
        />
      }
      label={<S.Label>{label}</S.Label>}
      sx={
        removePadding
          ? {
              marginLeft: "0 !important",
              marginRight: "0 !important",
              "& .MuiCheckbox-root": {
                marginLeft: "0 !important",
                marginRight: "0 !important",
              },
            }
          : {}
      }
    />
  );
};

export default CheckboxComponent;
